import Button from "../Form/Button";

const EmptyPage = ({
  title,
  header,
  image,
  headtext,
  subtext,
  buttontext,
  onClick,
  ...props
}) => {
  return (
    <div className="bg-white ">
      <div className="px-10 flex flex-col justify-center items-center">
        {/* <p className="text-[20px] font-[900px] leading-7 BoldFonter ">{header}</p> */}
        <div className="flex flex-col items-center mt-10 md:mt-20">
          <img loading="lazy" src={image} alt="" />
          <p className="text-[#5B2E4F] text-[24px]  font-[900px] leading-8 BoldFonter text-center mt-4">
            {headtext}
          </p>
          <p className="text-[16px] font-[400px] text-center leading-6 mt-4 mb-10">
            {subtext}
          </p>
          <Button text={buttontext} onClick={onClick} />
        </div>
      </div>
    </div>
  );
};

export default EmptyPage;
